export const userRoles = [
  ["admin", "Admin"],
  ["read_only", "Read Only"],
  ["regular", "Regular User"],
];
